import { PartialTranslation } from '../translations';

export const bs: PartialTranslation = {
  newChat: 'Novi razgovor',
  search: 'Pretraži',
  user: 'Korisnik',
  settings: 'Postavke',
  language: 'Jezik',
  getHelp: 'Dobiti pomoć',
  viewAllPlans: 'Pogledajte sve planove',
  learnMore: 'Saznajte više',
  logOut: 'Odjaviti se',
  chooseLanguage: 'Odaberite jezik',
  chooseYourPreferredLanguage: 'Odaberite željeni jezik',
  searchLanguages: 'Pretražite jezike...',
  autoDetect: 'Automatska detekcija',
  noLanguagesFound: 'Nisu pronađeni jezici',
  askAnything: 'Pitajte bilo što',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Lični',
  freePlan: 'Besplatan plan',
  current: 'Trenutni',
  close: 'Zatvoriti',
  archive: 'Arhivirati',
  delete: 'Obrisati',
  confirmDelete: 'Jeste li sigurni da želite obrisati ovaj razgovor?',
  confirmArchive: 'Jeste li sigurni da želite arhivirati ovaj razgovor?',
  deleteCannotUndo: 'Ova radnja se ne može poništiti.',
  archiveCanFind: 'Možete je pronaći u listi arhive nakon arhiviranja.',
  // 资源面板
  resources: 'Resursi',
  addResource: 'Dodaj resurs',
  deleteResource: 'Obriši resurs',
  noMatchingResourcesFound: 'Nisu pronađeni odgovarajući resursi',
  noResourcesAvailable: 'Nema dostupnih resursa',
  hideResources: 'Sakrij resurse',
  showResources: 'Prikaži resurse',
  
  // 聊天输入框
  typeMessage: 'Napišite poruku...',
  thinkingOptions: 'Opcije razmišljanja',
  deleteFile: 'Obriši fajl',
  clearSelection: 'Očisti selekciju',
  
  // 思考模式选项
  deepInsight: 'Duboki uvid · Površinska analiza',
  deepInsightDesc: 'Brzo razumijevanje ključnih tačaka',
  deepExploration: 'Duboko istraživanje · Sveobuhvatna analiza',
  deepExplorationDesc: 'Višedimenzionalno dubinsko istraživanje',
  deepDeconstruction: 'Duboka dekonstrukcija · Sistematski argument',
  deepDeconstructionDesc: 'Analiza sloj po sloj',
  
  // 写作模式选项
  contractReview: 'Pregled ugovora · Identifikacija rizika',
  contractReviewDesc: 'Analiza klauzula i provjera usaglašenosti',
  textPolish: 'Poliranje teksta · Profesionalno izražavanje',
  textPolishDesc: 'Optimizacija jezika i prilagođavanje strukture',
  legalDocuments: 'Pravni dokumenti · Standardno pisanje',
  legalDocumentsDesc: 'Profesionalno pisanje pravnih dokumenata',
  addAttachment: 'Dodaj prilog',
  sendMessage: 'Pošalji poruku',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Prijava',
  register: 'Registracija',
  welcomeBack: 'Dobrodošli u LawHelper',
  loginSubtitle: 'Vaš AI asistent za pravna istraživanja',
  continueWithGoogle: 'Nastavi s Google',
  continueWithMicrosoft: 'Nastavi s Microsoft',
  continueWithWeChat: 'Nastavi s WeChat',
  orContinueWith: 'ili nastavi s',
  emailTab: 'Email',
  phoneTab: 'Telefon',
  emailPlaceholder: 'Unesite svoj email',
  phonePlaceholder: 'Unesite broj telefona',
  codePlaceholder: 'Unesite 6-cifreni kod',
  sending: 'Slanje...',
  verifying: 'Provjera...',
  verify: 'Potvrdi',
  sendMagicLink: 'Pošalji čarobni link',
  getVerificationCode: 'Dobij kod',
  resendCode: 'Ponovo pošalji kod',
  resendIn: 'Ponovo pošalji za',
  magicLinkSent: 'Čarobni link je poslan na vaš email',
  magicLinkHint: 'Poslat ćemo siguran link na vaš email',
  otpSent: 'Verifikacijski kod je poslan',
  agreeToTerms: 'Nastavljanjem prihvatate naše',
  privacyPolicy: 'Politika privatnosti',
  termsOfService: 'Uslovi korištenja',
  and: 'i',
  privacyTitle: 'Vaša privatnost je važna',
  privacyIntro: 'Koristimo kolačiće i slične tehnologije za pružanje najboljeg iskustva.',
  essentialCookies: 'Neophodni kolačići',
  essentialDesc: 'Potrebni za funkcionisanje stranice',
  analyticsCookies: 'Analitički kolačići',
  analyticsDesc: 'Pomažu nam poboljšati uslugu',
  marketingCookies: 'Marketinški kolačići',
  marketingDesc: 'Koriste se za personalizovani sadržaj',
  acceptAll: 'Prihvati sve',
  essentialOnly: 'Samo neophodni',
  customize: 'Prilagodi',
  savePreferences: 'Sačuvaj postavke',
  back: 'Nazad',
  readPrivacyPolicy: 'Pročitajte našu politiku privatnosti',
  cookiePolicy: 'Politika kolačića',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI pregled',
  aiDraft: 'AI nacrt',
  smartAssistant: 'Predložak',

  // 知识库搜索
  enableKnowledgeSearch: 'Omogući pretragu',
  knowledgeSearchDesc: 'AI pretražuje vaše dokumente',
  clickToDisable: 'Onemogući',
  clickToEnable: 'Omogući',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Zatvori panel resursa',
  uploading: 'Slanje %{fileName}...',
  processing: 'Obrada %{fileName}...',
  uploadSuccess: '✓ %{fileName} poslano',
  uploadError: '✗ Slanje neuspješno: %{error}',
  quickAnswer: 'Brzi odgovor',
  quickAnswerDesc: 'Brzi odgovor na jednostavna pitanja',
  cancelRequest: 'Otkaži',
  library: 'Biblioteka',
  filterAll: 'Sve',
  filterChat: 'Razgovori',
  filterReview: 'Pregled',
  filterDraft: 'Nacrt',
  filterTemplate: 'Šablon',
  filterForm: 'Obrazac',
  thinking: 'Razmišljam...',
  thinkingProcess: 'Misaoni proces',
  analyzingLegalLogic: 'Analiza pravne logike...',
  lawhelperThinking: 'Lawhelper razmišlja...',
  serviceError: 'Greška servisa',
  uploaded: 'Poslano',
  settingsGeneral: 'Opšte',
  settingsNotifications: 'Obavještenja',
  settingsAppearance: 'Izgled',
  settingsProfile: 'Profil',
  settingsResponseNotifications: 'Obavještenja o odgovorima',
  settingsResponseNotificationsDesc: 'Obavještenje po završetku AI odgovora',
  settingsColorMode: 'Režim boja',
  settingsLight: 'Svijetlo',
  settingsDark: 'Tamno',
  settingsSystem: 'Sistem',
  about: 'O aplikaciji',
  reviewTitle: 'Pregled dokumenta',
  exitReview: 'Izađi iz pregleda',
  uploadPrompt: 'Pošaljite PDF za pregled',
  uploadButton: 'Izaberi fajl',
  startChatConfig: 'Napišite "Pregledaj ovaj dokument"',
  reviewPlaceholder: 'Unesite poruku...',
  analyzing: 'Pregledanje...',
  reviewComplete: 'Pregled završen',
  issuesFound: 'Pronađeno %{count} problema',
  draftTitle: 'Izrada pravnog dokumenta',
  draftPlaceholder: 'Uredite ovdje ili zatražite od AI...',
  analyzingTemplate: 'Analiza šablona %{name}...',
  templateAnalyzed: '✅ Šablon %{name} analiziran!',
  templateAnalysisPrompt: 'Analiziraj ključne klauzule',
  parsingFailed: '⚠️ Neuspješna analiza fajla.',
  generating: 'Generisanje...',
  generatedSuccess: '✅ Dokument generisan!',
  drafterWelcome: 'Dobrodošli u AI asistent za dokumente',
  drafterYouCan: 'Možete:',
  drafterUploadTemplate: 'Poslati šablon za AI analizu',
  drafterDescribeNeeds: 'Opisati zahtjeve dokumenta',
  drafterLetAiHelp: 'AI pomaže s ugovorima, sporazumima itd.',
  drafterExamples: 'Primjeri:',
  drafterExampleRental: '"Sastavite ugovor o zakupu"',
  drafterExampleLabor: '"Popunite ugovor o radu"',
  drafterInputPlaceholder: 'Opišite potrebe...',
  drafterThinking: 'Razmišljam...',
  drafterHistoryTitle: 'Historija',
  drafterNoHistory: 'Nema historije',
  drafterNewChat: 'Novi razgovor',
  drafterHistory: 'Historija',
  drafterRemoveAttachment: 'Ukloni prilog',
  drafterLineHeight: 'Visina reda',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Izvoz u Word (.docx)',
  drafterExportPdf: 'Izvoz u PDF',
  drafterSave: 'Sačuvaj dokument',
  drafterDownload: 'Preuzmi dokument',
  drafterUndo: 'Poništi',
  drafterRedo: 'Ponovi',
  drafterBold: 'Podebljano',
  drafterItalic: 'Kurziv',
  drafterStrike: 'Precrtano',
  drafterUnderline: 'Podvučeno',
  drafterHighlight: 'Istakni',
  drafterLink: 'Umetni link',
  drafterAlignLeft: 'Lijevo',
  drafterAlignCenter: 'Centar',
  drafterAlignRight: 'Desno',
  drafterAlignJustify: 'Obostrano',
  drafterList: 'Lista',
  drafterBulletList: 'Označena lista',
  drafterOrderedList: 'Numerisana lista',
  drafterTaskList: 'Lista zadataka',
  drafterOpenResource: 'Otvori resurse',
  drafterStopGeneration: 'Zaustavi generisanje',
  drafterAgentMode: 'Agent režim aktivan',
  drafterAgentModeOn: 'Agent režim aktivan',
  drafterAgentModeOff: 'Normalan režim',
  drafterUploadAttachment: 'Pošalji prilog',
  drafterExit: 'Izađi',
  drafterConfirm: 'Potvrdi',
  drafterOpenLink: 'Otvori link',
  drafterDeleteLink: 'Obriši link',
  drafterQuote: 'Citat',
  workflowTitle: 'AI proces',
  workflowRunning: 'Izvršava se...',
  workflowReady: 'Spreman',
  workflowCompleted: 'Završen',
  workflowStartFailed: 'Neuspješno pokretanje',
  workflowExecutionFailed: 'Neuspješno izvršavanje',
  workflowInterrupted: 'Proces prekinut',
  workflowProcessing: 'Obrada...',
  workflowStepsCompleted: 'koraka završeno',
  workflowStepsTotal: 'Proces završen (%{count} koraka)',
  acceptChanges: 'Prihvati promjene',
  rejectChanges: 'Odbaci promjene',
  changesAccepted: 'Promjene prihvaćene',
  changesRejected: 'Promjene odbačene',
  stopWorkflow: 'Zaustavi',
  restartWorkflow: 'Ponovo pokreni',
  startDrafting: 'Započni izradu',
  interrupt: 'Zaustavi',
  documentSubject: 'Tema dokumenta *',
  documentType: 'Tip dokumenta',
  jurisdiction: 'Jurisdikcija',
  specialRequirements: 'Posebni zahtjevi (opcionalno)',
  clickStartDrafting: 'Kliknite "Započni izradu"',
  docTypeContract: 'Ugovor',
  docTypeAgreement: 'Sporazum',
  docTypeNotice: 'Obavještenje',
  docTypeLetter: 'Pismo',
  docTypePetition: 'Peticija',
  docTypeWill: 'Testament',
  docTypePowerOfAttorney: 'Punomoć',
  countryChina: 'Kina',
  countryUSA: 'SAD',
  countryGermany: 'Njemačka',
  countryJapan: 'Japan',
  countryFrance: 'Francuska',
  countryUK: 'Ujedinjeno Kraljevstvo',
  citationVerified: 'Verificirano',
  citationUnverified: 'Neverificirano',
  imageLoadFailed: 'Neuspješno učitavanje slike',
  smartDocTitle: 'Pametni asistent',
  smartDocChatTitle: 'AI asistent za dokumente',
  smartDocDropPrompt: 'Spustite PDF ovdje',
  smartDocSelectFile: 'Izaberi fajl',
  smartDocOr: 'ili',
  smartDocWelcomeTitle: 'Dobrodošli u AI asistent',
  smartDocWelcomeYouCan: 'Možete:',
  smartDocUploadForAI: 'Poslati šablon',
  smartDocDescribeDoc: 'Opisati zahtjeve',
  smartDocLetAIDraft: 'AI pomaže s ugovorima',
  smartDocExamples: 'Primjeri:',
  smartDocExampleRental: '"Sastavite ugovor o zakupu"',
  smartDocExampleLabor: '"Popunite ugovor o radu"',
  smartDocInputPlaceholder: 'Opišite potrebe...',
  smartDocRemoveAttachment: 'Ukloni prilog',
  smartDocOpenResources: 'Otvori resurse',
  smartDocExit: 'Izađi',
  reviewStartFailed: 'Neuspješno pokretanje pregleda',
  reviewFailed: 'Pregled neuspješan',
  reviewFoundIssues: 'Pregled završen, %{count} problema.',
  cannotReadStream: 'Ne može se čitati tok',
  parseEventFailed: 'Neuspješna analiza događaja',
  errorPrefix: 'Greška',
  unknownError: 'Nepoznata greška',
  file: 'Fajl',
  loading: 'Učitavanje...',
  localFolders: 'Lokalni folderi',
  selectLocalFolder: 'Izaberi lokalni folder',
  reselectFolder: 'Promijeni folder',
  addToContext: 'Dodaj u razgovor',
  saveFile: 'Sačuvaj',
  renameFile: 'Preimenuj',
  fileSaved: 'Fajl sačuvan',
  fileRenamed: 'Fajl preimenovan u %{name}',
  browserNotSupported: 'Pretraživač ne podržava pristup folderima',
  noFolderSelected: 'Izaberite lokalni folder',
  scanningFolder: 'Skeniranje foldera...',
  selectFileToPreview: 'Izaberite fajl za pregled',
  aiAnalyze: 'AI analiza',
};
